export default [
	{
		modulo: 27,
		privilegio: 203,
		routerName: 'relatorio-aviacao-civil',
		routerPath: '/seguranca-operacional/relatorio-aviacao-civil',
		componentName: 'RelatorioAviacaoCivil',
		componentPath: 'modules/layout/seguranca-operacional/relatorio-aviacao-civil/lista'
	},
	{
		modulo: 27,
		privilegio: 203,
		routerName: 'relatorio-aviacao-civil-cadastrar',
		routerPath: '/seguranca-operacional/relatorio-aviacao-civil/cadastrar',
		componentName: 'RelatorioAviacaoCivilCadastrar',
		componentPath: 'modules/layout/seguranca-operacional/relatorio-aviacao-civil/formulario'
	},
	{
		modulo: 27,
		privilegio: 203,
		routerName: 'relatorio-aviacao-civil-visualizar',
		routerPath: '/seguranca-operacional/relatorio-aviacao-civil/visualizar/:id',
		componentName: 'RelatorioAviacaoCivilVisualizar',
		componentPath: 'modules/layout/seguranca-operacional/relatorio-aviacao-civil/visualizacao'
	},
	{
		modulo: 27,
		privilegio: 202,
		routerName: 'relatorio-gerenciamento-risco',
		routerPath: '/seguranca-operacional/relatorio-gerenciamento-risco',
		componentName: 'RelatorioGerenciamentoRisco',
		componentPath: 'modules/layout/seguranca-operacional/relatorio-gerenciamento-risco/lista'
	},
	{
		modulo: 27,
		privilegio: 202,
		routerName: 'relatorio-gerenciamento-risco-cadastrar',
		routerPath: '/seguranca-operacional/relatorio-gerenciamento-risco/cadastrar',
		componentName: 'RelatorioGerenciamentoRiscoCadastrar',
		componentPath: 'modules/layout/seguranca-operacional/relatorio-gerenciamento-risco/formulario'
	},
	{
		modulo: 27,
		privilegio: 202,
		routerName: 'relatorio-gerenciamento-risco-visualizar',
		routerPath: '/seguranca-operacional/relatorio-gerenciamento-risco/visualizar/:id',
		componentName: 'RelatorioGerenciamentoRiscoVisualizar',
		componentPath: 'modules/layout/seguranca-operacional/relatorio-gerenciamento-risco/visualizacao'
	},
	{
		modulo: 27,
		privilegio: 204,
		routerName: 'relatorio-inicial-resposta-emergencia',
		routerPath: '/seguranca-operacional/relatorio-inicial-resposta-emergencia',
		componentName: 'RelatorioInicialRespostaEmergencia',
		componentPath: 'modules/layout/seguranca-operacional/relatorio-inicial-resposta-emergencia/lista'
	},
	{
		modulo: 27,
		privilegio: 204,
		routerName: 'relatorio-inicial-resposta-emergencia-cadastrar',
		routerPath: '/seguranca-operacional/relatorio-inicial-resposta-emergencia/cadastrar',
		componentName: 'RelatorioInicialRespostaEmergenciaCadastrar',
		componentPath: 'modules/layout/seguranca-operacional/relatorio-inicial-resposta-emergencia/formulario'
	},
	{
		modulo: 27,
		privilegio: 204,
		routerName: 'relatorio-inicial-resposta-emergencia-visualizar',
		routerPath: '/seguranca-operacional/relatorio-inicial-resposta-emergencia/visualizar/:id',
		componentName: 'RelatorioInicialRespostaEmergenciaVisualizar',
		componentPath: 'modules/layout/seguranca-operacional/relatorio-inicial-resposta-emergencia/visualizacao'
	}
]
